<template>
  <div class="custom-targeting-list-table">
    <div v-if="loading && genericData.length === 0" class="text-center">
      <Loader :size="'big'" />
    </div>
    <template v-else>
      <div class="table-responsive position-relative">
        <!--begin::Table-->
        <table class="table align-middle table-row-dashed fs-6 gy-5">
          <!--begin::Table head-->
          <thead>
            <tr class="text-start text-gray-400 fw-bold fs-7 text-uppercase gs-0">
              <th
                v-for="(header, index) in tableHeaders"
                :key="index"
                class="min-w-100px"
              >
                {{ header.label }}
              </th>
            </tr>
          </thead>
          <!--end::Table head-->

          <!--begin::Table body-->
          <tbody class="fw-semibold text-gray-600">
            <tr v-for="(row, rowIndex) in genericData" :key="row.id || rowIndex">
              <td
                v-for="(header, colIndex) in tableHeaders"
                :key="colIndex"
              >
                <!-- se header.render existir, chama ele -->
                <span v-if="header.render">
                  {{ header.render(row) }}
                </span>
                <!-- caso contrário, mostra direto o campo -->
                <span v-else>
                  {{ row[header.key] || '--' }}
                </span>
              </td>
            </tr>
          </tbody>
          <!--end::Table body-->
        </table>
        <!--end::Table-->
      </div>

      <div class="text-center mt-4">
        <Button
          class="btn-primary"
          :loading="loading"
          @click="loadMore"
          v-if="isLoadMoreVisible"
        >
          Carregar mais
        </Button>
      </div>
    </template>
  </div>
</template>

<script>

import Button from '@/components/common/Button/Button'
import Loader from '@/components/common/Loader/Loader'

export default {
  name: 'GenericTable',
  props: {
    genericData: { type: Array, default: () => [] },
    reload: { type: Boolean, default: false },
    isLoadMoreVisible: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    tableHeaders: { type: Array, required: true }
  },
  components: {
    Button,
    Loader
  },
  watch: {
    reload (newValue) {
      if (newValue) this.$emit('reset')
    }
  },
  methods: {
    loadMore () {
      this.$emit('load-more')
    }
  }
}
</script>
